import Index from '../../pages/hjwq/kfhd2/index';
import Help from '../../pages/hjwq/kfhd2/help';
import Query from '../../pages/hjwq/kfhd2/query';
import Pc from '../../pages/hjwq/kfhd2/pc';

const base = 'kfhd_2';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  },
  {
    path: `/${base}/query*`,
    name: `${base}-query`,
    component: Query
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/hjwq/kfhd2.js